// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: var(--spacing-large) var(--spacing-medium);
  gap: var(--spacing-medium);
  height: 100%;
  min-width: 100%;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mDAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AADF","sourcesContent":["@use \"../../shared/components/media-queries\" as mq;\n\n:host {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: var(--spacing-large) var(--spacing-medium);\n  gap: var(--spacing-medium);\n  height: 100%;\n  min-width: 100%;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
